import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=6fde070e&scoped=true&"
import script from "./FAQs.vue?vue&type=script&lang=ts&"
export * from "./FAQs.vue?vue&type=script&lang=ts&"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=6fde070e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde070e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
